import { ELanguage } from '@web_opxp/features';

export interface IFeedbackState {
  isSent: boolean;
  show: boolean;
  text: string;
}

export enum EFeedbackType {
  positive = 'positive',
  negative = 'negative',
  later = 'later',
}

export interface IFeedbackData {
  subject: string;
  recipient: string;
  rating: EFeedbackType;
  currentCycle: number;
  currentSession: number;
  message: string;
  userName: string;
  userId: number;
  isPremium: 'True' | 'False';
  osName: string;
  userAgent: string;
  language: ELanguage;
  lastGameplay: string;
}

export interface IWebRatingRequestConfig {
  enabled: boolean;
  after_num_workouts: number;
  on_min_accuracy: number;
  days_after_positive: number;
  days_after_negative: number;
  days_after_later: number;
}

export interface ISendFeedbackPayload {
  text: string;
  rating: EFeedbackType;
}
